import { useId, useState } from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import styles from '../../../styles/styles.module.css';

export default function ArraySelector({
  items = [],
  onSelect,
  label = 'Selecionar',
  isDisabled = false,
}) {
  const [show, setShow] = useState(false);
  const generatedId = useId();
  const dropdownId = `dropdown-${label.toLowerCase().replace(/\s+/g, '-')}-${generatedId}`;

  const handleToggle = (isOpen) => {
    setShow(isOpen);
  };

  const handleItemClick = (item) => {
    if (onSelect) {
      onSelect(item);
    }
    setShow(false);
  };

  const itemList = Array.isArray(items) ? items : [];

  return (
    <DropdownButton
      id={dropdownId}
      show={show}
      onToggle={handleToggle}
      title={label}
      variant="outline-primary"
      size="sm"
      disabled={isDisabled}
      menuRole="menu"
    >
      <div style={{ maxHeight: '280px', overflowY: 'auto' }}>
        {itemList.length === 0 ? (
          <Dropdown.Item disabled className={styles.arraySelectorItem}>
            Nenhuma opção disponível
          </Dropdown.Item>
        ) : (
          itemList.map((item, index) => (
            <Dropdown.Item
              key={`${item}-${index}`}
              className={styles.arraySelectorItem}
              onClick={() => handleItemClick(item)}
            >
              {item}
            </Dropdown.Item>
          ))
        )}
      </div>
    </DropdownButton>
  );
}
